'use strict';

angular.module('docketbook').
  service('xeroService', function (accessControl, userService, $http, $stateParams, $cookies, $q, $timeout, Restangular, geolocation) {

    var currentOrg = accessControl.currentOrg();
    var currentOrgGroup = accessControl.currentOrgGroup();


    /***** Get Xero Quotes *****/
    this.getXeroQuotes = function (params, successCb, failureCb) {
      var currentOrg = accessControl.currentOrg();
      var currentOrgGroup = accessControl.currentOrgGroup();
      var baseQuotes = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('xero/quotes');
      baseQuotes.getList(params).then(function (quotes) {
        successCb(quotes);
      }, failureCb);
    }

    /***** Get Xero Quote *****/
    this.getXeroQuote = function (quoteId, successCb, failureCb) {
      var baseQuotes = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('xero').all('quotes');
      baseQuotes.one(quoteId).customGET("", {}).then(function (quote) {
        successCb(quote[0]);
      }, failureCb);
    }

    /***** Update Xero Quote *****/
    this.markXeroQuoteInvoiced = function (quoteId, successCb, failureCb) {
      var baseQuotes = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('xero').all('quotes');
      baseQuotes.one(quoteId).all('markinvoiced').customPOST({}).then(function (quote) {
        successCb(quote[0]);
      }, failureCb);
    }

    /***** Get Xero Contacts *****/
    this.getXeroContacts = function (successCb, failureCb) {
      var currentOrg = accessControl.currentOrg();
      var currentOrgGroup = accessControl.currentOrgGroup();
      var baseContacts = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('xero/contacts');
      baseContacts.getList().then(function (contacts) {
        successCb(contacts);
      }, failureCb);
    }

    /***** Get Xero Items *****/
    this.getXeroItems = function (params, successCb, failureCb) {
      if (params == null) {
        params = {}
      }
      var currentOrg = accessControl.currentOrg();
      var currentOrgGroup = accessControl.currentOrgGroup();
      var baseItems = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('xero/items');
      baseItems.getList(params).then(function (items) {
        successCb(items);
      }, failureCb);
    }

    /***** Get Xero Items ******/
    /*this.getXeroItems = function(params, successCb, failureCb) {
      var currentOrg = accessControl.currentOrg();
      var currentOrgGroup = accessControl.currentOrgGroup();
      var organisationId = null;
      var organisationGroupId = null;
      if ( params && params.organisationId ) {
        organisationId = params.organisationId;
      } else {
        organisationId = currentOrg.id;
      }
      if ( params & params.organisationGroupId ) {
        organisationGroupId = params.organisationGroupId;
      } else {
        organisationGroupId = currentOrgGroup.id;
      }
      var baseItems = Restangular.all('organisations').one(organisationId).all('groups').one(organisationGroupId).all('xero/liveitems');
      baseItems.getList(params).then(function(items) {
        successCb(items);
      }, failureCb);
    }*/

    /***** Get Xero Organisation *****/
    this.getXeroOrganisation = function (successCb, failureCb) {
      var currentOrg = accessControl.currentOrg();
      var currentOrgGroup = accessControl.currentOrgGroup();
      var baseContacts = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('xero/organisation/current');
      baseContacts.customGET().then(function (currentXeroOrg) {
        successCb(currentXeroOrg);
      }, failureCb);
    }

    /***** Get Xero Auth Tenants *****/
    this.getXeroAuthTenants = function (successCb, failureCb) {
      var currentOrg = accessControl.currentOrg();
      var currentOrgGroup = accessControl.currentOrgGroup();
      var baseContacts = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('xero/authtenants');
      baseContacts.customGET().then(function (authDetails) {
        successCb(authDetails);
      }, failureCb);
    }

    /***** Create Xero Invoice From a Batch *****/
    this.createXeroInvoice = function (data, successCb, failureCb) {
      var currentOrg = accessControl.currentOrg();
      var currentOrgGroup = accessControl.currentOrgGroup();
      var baseXeroExport = Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('docket_batches').one(data.id).all('export/xero');
      baseXeroExport.customPOST({}, null, { target: data.target, type: data.type, includeSupporting: data.includeSupporting, xeroCustomerId: data.xeroCustomerId }).then(successCb, failureCb);
    }


    this.xeroContactSync = function (finishedCb) {
      Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('xero').all('contacts').one('sync').customPOST().then(function (response) {
        var jobId = response.id;
        checkForXeroSyncCompletion(jobId, finishedCb);
      }, function (err) {

      });
    }

    this.xeroItemSync = function (finishedCb) {
      Restangular.all('organisations').one(currentOrg.id).all('groups').one(currentOrgGroup.id).all('xero').all('items').one('sync').customPOST().then(function (response) {
        var jobId = response.id;
        checkForXeroSyncCompletion(jobId, finishedCb);
      }, function (err) {

      })
    }

    var checkForXeroSyncCompletion = function (jobId, finishedCb) {
      $timeout(function () {
        userService.getTaskStatus(jobId, function (taskInfo) {
          if (taskInfo.status == 'In Progress') {
            checkForXeroSyncCompletion(jobId, finishedCb);
          } else {
            finishedCb && finishedCb(taskInfo)
          }
        }, function (err) {
          console.error('could not get task status', err);
        });
      }, 1000);
    }

  });



// WEBPACK FOOTER //
// ./src/services/xeroService.js